import React, { useContext, useState } from 'react'
import UserContext from '../../data/user'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Form from '../../components/FormCreator'
import { Link as LinkButton } from '../../components/Button'
const ResetPasswordConfig = [
    { name: 'password', label: 'password', type: 'password', span: '1/-1' },
    { name: 'captcha', label: 'captcha', type: 'captcha', span: '1/-1' },
]
const PasswordReset = () => {
    const [openPasswordForgot, setOpenPasswordForgot] = useState()
    const { token } = useParams()
    const userCtx = useContext(UserContext)
    const navigate = useNavigate()
    const api = userCtx.api
    return (
        <>
            <Form
                fields={ResetPasswordConfig}
                title="Fill out a new password"
                onSubmit={async (newPassword) => {
                    // try {
                    return await api
                        .resetPassword(newPassword, token)
                        .then((user) =>
                            api.login({
                                email: user.email,
                                password: newPassword.password,
                            })
                        )
                        .then(() => {
                            navigate('/my/user')
                        })
                    // } catch (e) {
                    //     console.error(e)
                    //     setHasError(true)
                    // }
                }}
            ></Form>
        </>
    )
}

export default PasswordReset
